import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  login: false,
  locale: "",
  cartNumber: 0,
  locales: ["en", "zh-CN", "es"],
  userInfo: 
    typeof localStorage !== 'undefined' && localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {},
  merchantType: [] /** 商户类型 **/,
  productClassify: [],
  bottomData: [],
  merchantClassify: [] /** 商户分类 **/,
  isShowTourists: false,
  evaluationInfo: (() => {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem("evaluationInfo");
      if (stored) {
        try {
          return JSON.parse(stored);
        } catch (e) {
          return {};
        }
      }
    }
    return {};
  })(),
  merPcBanner:
    typeof localStorage !== 'undefined' && localStorage.getItem("merPcBanner")
      ? JSON.parse(localStorage.getItem("merPcBanner"))
      : [] /** 商户主页banner轮播图  **/,
  currencyUnit: (() => {
    // 初始化币种单位：1是人民币，2是美元
    if (typeof localStorage !== 'undefined') {
      const unit = localStorage.getItem("unit");
      if (unit) {
        try {
          return JSON.parse(unit);
        } catch (e) {
          return 2;
        }
      }
    }
    return 2;
  })(),
};

const mutations = {
  isLogin(state, data) {
    state.login = data;
  },
  isTourists(state, data) {
    state.isShowTourists = data;
  },
  SET_LANG(state, locale) {
    state.locale = locale;
  },
  cartNum(state, data) {
    state.cartNumber = Number(data);
  },
  /** 店铺全部类型 **/
  SET_MerchantType: (state, merchantType) => {
    state.merchantType = merchantType;
  },
  /** 商品分类 **/
  SET_ProductClassify: (state, productClassify) => {
    state.productClassify = productClassify;
  },
  /** 底部数据 **/
  SET_BottomData: (state, bottomData) => {
    state.bottomData = bottomData;
  },
  /** 商户全部分类  **/
  SET_MerchantClassify: (state, merchantClassify) => {
    state.merchantClassify = changeNodes(merchantClassify);
  },
  /** 评价列表中的商品信息  **/
  SET_EvaluationInfo: (state, evaluationInfo) => {
    state.evaluationInfo = evaluationInfo;
    localStorage.setItem("evaluationInfo", JSON.stringify(evaluationInfo));
  },
  /** 商户主页banner轮播图  **/
  SET_MerPcBanner: (state, merPcBanner) => {
    state.merPcBanner = merPcBanner;
    localStorage.setItem("merPcBanner", merPcBanner);
  },
  SET_USER_INFO: (state, userInfo) => {
    
    state.userInfo = userInfo

    console.log(state.userInfo);
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  /** 设置币种单位 **/
  SET_CURRENCY_UNIT: (state, unit) => {
    state.currencyUnit = unit;
    localStorage.setItem('unit', JSON.stringify(unit));
  },
};

/** tree去除 childList=[] 的结构**/
const changeNodes = function (data) {
  if (data.length > 0) {
    for (var i = 0; i < data.length; i++) {
      if (!data[i].childList || data[i].childList.length < 1) {
        data[i].childList = undefined;
      } else {
        changeNodes(data[i].childList);
      }
    }
  }
  return data;
};

const actions = {

  /** 店铺类型 **/
  MerTypeList({ state, commit }) {
    return new Promise((reslove) => {
      this.$axios.get(`/api/front/merchant/all/type/list`).then((res) => {
        commit("SET_MerchantType", res.data);
        reslove(res.data);
      });
    }).catch((err) => {
      reject(error);
    });
  },
  /** 商户分类 **/
  MerCategoryList({ state, commit }) {
    return new Promise((reslove) => {
      this.$axios.get(`/api/front/merchant/all/category/list`).then((res) => {
        commit("SET_MerchantClassify", res.data);
        reslove(res.data);
      });
    }).catch((err) => {
      reject(error);
    });
  },
  /** 商品分类 **/
  getProductClassify({ state, commit }) {
    return new Promise((reslove) => {
      this.$axios.get(`/api/front/product/category`).then((res) => {
        commit("SET_ProductClassify", changeNodes(res.data));
        reslove(res.data);
      });
    }).catch((err) => {
      reject(error);
    });
  },
};

const getters = {
  /** 获取币种符号 **/
  currencySymbol: (state) => {
    return state.currencyUnit == 1 ? '￥' : '$';
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});
